import { useForm } from 'react-hook-form';
import Toast from '../../../shared/Toast/Toast';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
  useCreateServiceCall,
  useSupportCategoryById,
  useSupportSubCategoryById,
} from '../../../../store/support-management/SupportHooks';
import { AddServiceCallForm } from '../AddServiceCallForm';
import { useProfile } from '../../../../store/Auth/authHooks';
import { Button, Form, ModalFooter, ModalHeader } from 'reactstrap';
import ServiceCallSupport from '../ServiceCallSupport/ServiceCallSupport';
import { createNewServiceCallDataType } from '../../../../store/support-management/SupportDto';

type PropsTypes = {
  setShowSuccessPage: React.Dispatch<React.SetStateAction<boolean>>;
  setServiceCallId: (value: number) => void;
};

export interface ServiceCallFormValues {
  buildingVisitId: string;
  spaceVisitId: string;
  categoryId: string;
  subCategoryId: string;
  message: string;
  subject: string;
  files: string[];
}

const AddServiceCallContent = (props: PropsTypes) => {
  const profile = useProfile();
  const { t } = useTranslation();
  const createServiceCall = useCreateServiceCall();

  const form = useForm({
    defaultValues: {
      categoryId: '',
      subCategoryId: '',
      files: [],
      subject: '',
    },
  });
  const { handleSubmit } = form;

  const [isCategoryPicked, setIsCategoryPicked] = useState(false);
  const category = useSupportCategoryById(form.watch('categoryId'));
  const subCategory = useSupportSubCategoryById(form.watch('subCategoryId'));

  const categoryId = form.watch('categoryId').toString();
  const subCategoryId = form.watch('subCategoryId').toString();

  const onSubmit = async (data: ServiceCallFormValues) => {
    const newData: createNewServiceCallDataType = {
      buildingVisitId: data.buildingVisitId,
      spaceVisitId: data.spaceVisitId,
      categoryCode:
        categoryId === '-1'
          ? profile.company?.companyUniqueVisitId!
          : category!.code,
      subCategoryCode: categoryId === '-1' ? subCategoryId : subCategory!.code,
      message: data.message,
      subject: data.subject,
    };

    try {
      const serviceCallId = await createServiceCall(newData);
      props.setServiceCallId(serviceCallId);
      onSuccess();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        'Failed to create service call';
      if (errorMessage) {
        onFailure(errorMessage);
      }
    }
  };

  const onSuccess = () => {
    props.setShowSuccessPage(true);
  };

  const onFailure = (errorMessage: string) => {
    const toastType = 'error';
    Toast(toastType, errorMessage, t);
  };

  useEffect(() => {
    setIsCategoryPicked(Number.isInteger(form.control._formValues.categoryId));
  }, [form.control._formValues.categoryId]);

  return (
    <div>
      <Form onSubmit={handleSubmit(onSubmit)} className="form">
        <ModalHeader>
          <p className="form-header-title">
            {t('CREATE_NEW_SERVICE_CALL_TITLE')}
          </p>
        </ModalHeader>
        <>
          <AddServiceCallForm form={form} />
          {isCategoryPicked && <ServiceCallSupport />}
        </>
        <ModalFooter
          className="add-category-modal-buttons"
          style={{ display: isCategoryPicked ? 'flex' : 'none' }}
        >
          <Button
            type="button"
            color=""
            onClick={() => form.reset()}
            className="service-call-modal-cancel-button"
          >
            {t('CREATE_NEW_SERVICE_CALL_DISCARD_BUTTON')}
          </Button>{' '}
          <Button type="submit" color="primary">
            {t('CREATE_NEW_SERVICE_CALL_SUBMIT_BUTTON')}
          </Button>{' '}
        </ModalFooter>
      </Form>
    </div>
  );
};

export default AddServiceCallContent;
